import * as React from 'react';
import { css } from '@emotion/core';
import Modal from './Modal';
import ModalHeader from './ModalHeader';
import LocalDiv from '../../localization/LocalDiv';
import LocalBtn from '../../localization/LocalBtn';
import Spacer from '../Spacer';
import { btnStyle } from '../../forms/styles/button';
import { COLORS } from '../../globalStyle/colors';
import { FLEX_ROW, FLEX_COLUMN } from '../flexBox';


const styles = {
  root:            [
    FLEX_COLUMN,
    css`
      min-height: 300px;
      max-width: 565px;
    `,
  ],
  modalContent:    [
    FLEX_COLUMN,
    css`
      flex-grow: 1;
      justify-content: space-between;
    `,
  ],
  confirmationTxt: css`
    display: block;
    font-size: 18px;
    color: ${COLORS.DARK_GREY};
    font-weight: bold;
    line-height: 23px;
    overflow-wrap: break-word;
    margin: 65px 85px 85px;
    
    @media only screen and (max-width: 470px) {
      margin: 65px 20px 85px;
    }
  `,
  btnRow:          [
    FLEX_ROW,
    css`
      justify-content: flex-end;
      margin: 0 20px 20px;
    `,
  ],
  secondaryBtn:    [
    btnStyle.secondary(COLORS.BLUE),
    css`
      min-width: 135px;
    `,
  ],
  primaryBtn:      [
    btnStyle.primary(COLORS.BLUE),
    css`
      min-width: 135px;
    `,
  ],
};


type Props = {
  confirmationTxt: string;

  primaryActionStr: string;
  secondaryActionStr: string;

  onSelectPrimary: () => void;
  onSelectSecondary: () => void;

  onDismiss: () => void;

  className?: string;
};


/**
 * ConfirmationModal: a component that renders a modal with confirmation text and a primary/secondary button.
 * When the user makes a selection, the appropriate action handler is called.
 */
const ConfirmationModal: React.FC<Props> = props => (
  <Modal onDismiss={props.onDismiss} css={styles.root} className={props.className}>
    <ModalHeader onDismiss={props.onDismiss} />
    <div css={styles.modalContent}>
      <span css={styles.confirmationTxt}>{props.confirmationTxt}</span>
      <LocalDiv css={styles.btnRow}>
        <LocalBtn
          onClick={props.onSelectSecondary}
          str={props.secondaryActionStr}
          css={styles.secondaryBtn}
        />
        <Spacer sizePx={10} />
        <LocalBtn
          onClick={props.onSelectPrimary}
          str={props.primaryActionStr}
          css={styles.primaryBtn}
        />
      </LocalDiv>
    </div>
  </Modal>
);

export default ConfirmationModal;
